import React, { Component, Suspense, lazy, useState, useEffect } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Spinner from '../app/shared/Spinner'

import UserKyc from './components/userManagement/UserKyc'
import ViewKyc from './components/userManagement/ViewKyc'
import Transactionhistory from './components/transaction/Transactionhistory'
import Bonushistory from './components/transaction/Bonushistory'
import Withdrawlhistory from './components/transaction/Withdrawlhistory'
import Deposits from './components/transaction/Deposits'
import Pages from './components/Settings/Page'

import axios from 'axios'

import Earings from './dashboard/Earings'
import AgentDash from './dashboard/AgentDash'
import ComKyc from './components/userManagement/ComKyc'
import SucWithdraw from './components/transaction/SucWithdraw'
import RejectKyc from './components/userManagement/RejectKyc'
import Completed from './components/challengeManagement/Completed'
import Conflict from './components/challengeManagement/Conflict'
import Cancelled from './components/challengeManagement/Cancelled'
import Running from './components/challengeManagement/Running'
import Pending from './components/challengeManagement/Pending'
import New from './components/challengeManagement/New'
import View from './components/userManagement/View'
import Allhistory from './components/userManagement/Allhistory'
import UpdatePassword from './components/adminManagement/UpdatePassword'
import Profile from './components/adminManagement/Profile'
import Permissions from './components/agentManagement/Permissions'

import DepositReport from './components/Reports/DepositReport'
import BonusReport from './components/Reports/BonusReport'
import WithdrawalReport from './components/Reports/WithdrawalReport'
import CommissionReport from './components/Reports/CommissionReport'
import RefferalReport from './components/Reports/RefferalReport'
import PenaltyReport from './components/Reports/PenaltyReport'
import { Sitesettings } from './components/adminManagement/Sitesettings'
import Notification from './components/messaging/Notification'
import Chat from './components/messaging/Chat'
import Invoice from './components/transaction/Invoice'
// import Bonus from './components/transaction/Bonus';
import Bonus from './components/transaction/bonus'
import NewChat from './components/messaging/NewChat'
import BlockUser from './components/Reports/BlockUser'
import DepositManual from './components/transaction/DepositManual'
import { Security } from '@mui/icons-material'
import Gateway from './components/adminManagement/Gateway'
import AgentData from './components/adminManagement/AgentData'
import BankDetails from './components/adminManagement/Bankdetails'
import Permission from './components/adminManagement/Permission'
import ConflictHistory from './components/challengeManagement/ConflictHistory'
import AgentWallet from './components/agentManagement/AgentWallet'
import WalletHistory from './components/agentManagement/WalletHistory'
import WithdrawVerify from './components/transaction/WithdrawVerify'
import DepositVerify from './components/transaction/DepositVerify'
import ReferDeposit from './components/transaction/ReferDeposit'
import Alllogs from './components/adminManagement/Alllogs'
import OnlineKyc from './components/userManagement/OnlineKyc'
// import security from './Security'

// Admin Management start
const Alladmin = lazy(() => import('./components/adminManagement/Alladmin'))
const Addadmin = lazy(() => import('./components/adminManagement/Addadmin'))
// Admin Management end

// Game Management start
const Allgames = lazy(() => import('./components/gameManagement/Allgames'))
const Addgame = lazy(() => import('./components/gameManagement/Addgame'))
// Game Management end

// User Management start
const Allusers = lazy(() => import('./components/userManagement/Allusers'))
const Adduser = lazy(() => import('./components/userManagement/Adduser'))
// User Management end

// Agent Management start
const Allagents = lazy(() => import('./components/agentManagement/Allagent'))
const Addagent = lazy(() => import('./components/agentManagement/Addagent'))
// User Management end

// Challenge Management start
const Allchallenges = lazy(() =>
  import('./components/challengeManagement/Allchallenge')
)
const Views = lazy(() => import('./components/challengeManagement/Views'))
// Challenge Management end

// Transaction Management start
const Alldeposits = lazy(() => import('./components/transaction/Deposits'))
const Allwithdrawl = lazy(() => import('./components/transaction/Withdrawl'))
const Penalty = lazy(() => import('./components/transaction/Penalty'))
// const Bonus = lazy(() => import('./components/transaction/Bonus'));
// Transaction Management end

const Dashboard = lazy(() => import('./dashboard/Dashboard'))

const Buttons = lazy(() => import('./basic-ui/Buttons'))
const Dropdowns = lazy(() => import('./basic-ui/Dropdowns'))
const Typography = lazy(() => import('./basic-ui/Typography'))

const BasicElements = lazy(() => import('./form-elements/BasicElements'))

const BasicTable = lazy(() => import('./tables/BasicTable'))

const Mdi = lazy(() => import('./icons/Mdi'))

const ChartJs = lazy(() => import('./charts/ChartJs'))

const Error404 = lazy(() => import('./error-pages/Error404'))
const Error500 = lazy(() => import('./error-pages/Error500'))

const Login = lazy(() => import('./user-pages/Login'))
const Register1 = lazy(() => import('./user-pages/Register'))

// const Homepage = lazy(() => import('../app2.js/uiComponents/Homepage'));

const readStored = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || 'null')
  } catch (e) {
    return null
  }
}

const AppRoutes = () => {
  const [loading, setLoading] = useState(false)
  const [permission, setPermission] = useState(() => readStored('PData'))
  const [udata, setudata] = useState(() => readStored('uData'))

  const access_token = localStorage.getItem('token')
 
  const [pages, setPages] = useState(false)

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }


  useEffect(() => {
    const meedata = localStorage.getItem("uData");
    const userData = JSON.parse(meedata);
    const permission1 = localStorage.getItem("PData");
    const pdata = JSON.parse(permission1);
    setPermission(pdata)
    setudata(userData)
  }, [])




    if (access_token) {
    if (!permission || !udata) {
      return <Spinner />
    }
    //  userData.user_type == 'Admin'
    
    return (
    <>
      <Suspense fallback={<Spinner />}>
        <Switch>
          <Redirect exact from='/' to={udata.user_type === 'Agent' ? '/dashboard/AgentDash' : '/dashboard'} />

          {permission.dashboard && (
            <Route exact path='/dashboard' component={Dashboard} />
          )}
          {
            permission.agentdashboard && (
              <Route path="/dashboard/AgentDash" component={AgentDash} />
            )
          }
          {permission.earnings && <Route exact path='/earinigs' component={Earings} />}

          {/* Admin Routes start */}
          {permission.allAdmins && (
            <Route path='/admin/alladmins' component={Alladmin} />
          )}
          {/* {permission.allAdmins && (
            <Route path='/admin/all-logs' component={Alllogs} />
          )}
          {permission.addBankDetail && (
            <Route path='/admin/Bankdetails' component={BankDetails} />
          )} */}
          {permission.newAdmin && <Route path='/admin/addadmin' component={Addadmin} />}
          {permission.newAdmin && <Route path='/user/onlineKyc' component={OnlineKyc} />}
          {permission.sitesettings && (
            <Route path='/admin/sitesettings' component={Sitesettings} />
          )}
          {permission.Gatewaysettings && (
            <Route path='/admin/getwaysettings' component={Gateway} />
          )}



          <Route path='/admin/update' component={UpdatePassword} />

          <Route path='/admin/profile' component={Profile} />
          {/* <Route path='/agent/permissions/:id' component={Permissions} /> */}
          {
            permission.agentdashboard && (
              <Route path="/Agent/Data" component={AgentData} />
            )
          }

          {/* Admin Routes end */}

          {/* Game Routes start */}

          <Route path='/game/allgames' component={Allgames} />
          <Route path='/game/addgame' component={Addgame} />

          {/* Game Routes end */}

          {/* user Routes start */}
          {permission.allUsers && <Route path='/user/allusers' component={Allusers} />}
           {/* <Route path='/user/adduser/:id' component={Adduser} /> */}

           <Route path='/user/adduser' component={Adduser} />
          {permission.pendingKyc && <Route path='/user/UserKyc' component={UserKyc} />}
          <Route path='/user/view' component={ViewKyc} />
          {permission.completedKyc && <Route path='/user/kyc' component={ComKyc} />}
          {permission.rejectKyc && <Route path='/user/reject' component={RejectKyc} />}
          <Route path='/user/view_user/:id' component={View} />
          <Route path='/user/allhistory/:id' component={Allhistory} />

          {/* user Routes end */}

          {/* Agent Routes start */}

          {
            permission.allAgent && (
              <Route path='/agent/allagents' component={Allagents} />
            )
          }
          {
            permission.allAgent && (
              <Route path='/agent/permission/:id' component={Permission} />
            )
          }
          {
            permission.newAdmin && (
              <Route path='/agent/addagent' component={Addagent} />
            )
          }
          {/* Agent Routes end */}

          {/* challenge Routes start */}
          {permission.allChallenges && (
            <Route
              path='/challenge/allchallenges'
              component={Allchallenges}
            />
          )}
          {permission.completedChallenges && (
            <Route
              path='/challenge/completed_challange'
              component={Completed}
            />
          )}
          {permission.conflictChallenges && (
            <Route
              path='/challenge/conflict_challange'
              component={Conflict}
            />
          )}
          {permission.conflictChallenges && (
            <Route
              path='/all/challenge/conflict_challange'
              component={ConflictHistory}
            />
          )}
          {permission.cancelledChallenges && (
            <Route
              path='/challenge/cancelled_challange'
              component={Cancelled}
            />
          )}
          {permission.runningChallenges && (
            <Route path='/challenge/running_challange' component={Running} />
          )}
          {permission.pendingChallenges && (
            <Route path='/challenge/pending_challange' component={Pending} />
          )}
          {permission.newChallenge && (
            <Route path='/challenge/new_challange' component={New} />
          )}

          {/* challenge Routes end */}

          {/* Transaction Routes start */}
          {permission.allDepositRequests && (
            <Route path='/transaction/alldeposits' component={Alldeposits} />
          )}
          {permission.allWithdrawlRequests && (
            <Route
              path='/transaction/allwithdrawl'
              component={Allwithdrawl}
            />
          )}
          {permission.penalty && (
            <Route path='/transaction/penalty' component={Penalty} />
          )}
          {permission.bonus && <Route path='/transaction/bonus' component={Bonus} />}
          {permission.agentWallet && <Route path='/agentWallet' component={AgentWallet} />}
          {permission.agentWallet && <Route path='/wallethistory' component={WalletHistory} />}
          {permission.depositHistory && (
            <Route
              path='/transaction/transaction_history'
              component={Transactionhistory}
            />
          )}
          {permission.depositHistory && (
            <Route
              path='/transaction/reffer_redeem'
              component={ReferDeposit}
            />
          )}
          {permission.manualDepositHistory && (
            <Route
              path='/transaction/deposit_manual'
              component={DepositManual}
            />
          )}
          {permission.bonusHistory && (
            <Route
              path='/transaction/bonus_history'
              component={Bonushistory}
            />
          )}
          {permission.withdrawlHistory && (
            <Route
              path='/transaction/withdraw_history'
              component={Withdrawlhistory}
            />
          )}
          {permission.withdrawVerify && (
            <Route
              path='/transaction/withdrawVerify'
              component={WithdrawVerify}
            />
          )}
          {permission.depositVerify && (
            <Route
              path='/transaction/depositVerify'
              component={DepositVerify}
            />
          )}
          <Route path='/transaction/withdraw' component={SucWithdraw} />

          {/* Transaction Routes end */}

          {/* Report Routes start */}
          {/* Added By Team */}
          {permission.bonusReport && (
            <Route path='/Reports/bonusReport' component={BonusReport} />
          )}
          {permission.penaltyReport && (
            <Route path='/Reports/penaltyReport' component={PenaltyReport} />
          )}
          {permission.withdrawlReport && (
            <Route
              path='/Reports/withdrawalReport'
              component={WithdrawalReport}
            />
          )}
          {permission.commissionReport && (
            <Route
              path='/Reports/CommissionReport'
              component={CommissionReport}
            />
          )}
          {permission.refferalReport && (
            <Route
              path='/Reports/Refferalreport'
              component={RefferalReport}
            />
          )}
          {permission.blockUser && (
            <Route
              path='/Reports/Blockuser'
              component={BlockUser}
            />
          )}
          {permission.depositReport && (
            <Route path='/Reports/depositReport' component={DepositReport} />
          )}
          {/* Added By Team */}
          {/* Report Routes Start */}

          <Route path='/basic-ui/buttons' component={Buttons} />
          <Route path='/basic-ui/dropdowns' component={Dropdowns} />
          <Route path='/basic-ui/typography' component={Typography} />

          <Route
            path='/form-Elements/basic-elements'
            component={BasicElements}
          />

          <Route path='/tables/basic-table' component={BasicTable} />

          <Route path='/icons/mdi' component={Mdi} />

          <Route path='/charts/chart-js' component={ChartJs} />

          <Route path='/user-pages/register-1' component={Register1} />

          <Route path='/error-pages/error-404' component={Error404} />
          <Route path='/error-pages/error-500' component={Error500} />
          <Route path='/view/:id' component={Views} />
          {pages && <Route path='/Pages' component={Pages} />}

          {/* Messaging Route */}
          <Route path='/user/notification' component={Notification} />
          <Route path='/user/chat' component={Chat} />
          <Route path='/user/newchat' component={NewChat} />

          <Route path='/invoice' component={Invoice} />
          <Route path='/security' component={Security} />
        </Switch>
      </Suspense>
    </>
  )
  } else {
    return <Redirect to="/login" />;
  }
}

export default AppRoutes
